import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmEntityContactContainerModel } from '../../../../../../models/aggregates/erp/mlm-admin';


@Injectable({ providedIn: 'root' })
export class MlmEntityContactService extends BaseApiTemplateService<MlmEntityContactContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/entity-contacts';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX   + 'mlm/entity-contacts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/entity-contacts';
    this.httpClient = theHttp;
  }


}

